import { Component, LOCALE_ID, Inject } from '@angular/core';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { DateLocale } from 'angular-md2';

@Component({
  selector: 'app-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent  {
  constructor(private localeService: BsLocaleService,
              private dateLocale: DateLocale,
              @Inject(LOCALE_ID) locale: string) {
    this.localeService.use(locale);

    if ( locale == "es" ) {
      dateLocale.firstDayOfWeek = 1;
      dateLocale.months = {
        long : ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        short: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        narrow: ['E', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D']
      };
      dateLocale.daysOfWeek = {
        long : ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        short: ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'],
        narrow: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
      };
    }
  }
}
